<template>
    <div class="page">
        <div class="header">
            <Header :current="['fw']"></Header>
            <div class="zt-title">我要贷款</div>
        </div>
        <div class="page-content">
            <div class="page-form">
                <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules" ref="formRef">
                    <a-form-item label="主体名称" name="subjectName">
                        <a-input v-model:value="formState.subjectName"  placeholder="输入主体名称"/>
                    </a-form-item>
                    <a-form-item label="镇街" name="town">
                        <a-select v-model:value="formState.town" placeholder="选择所在镇街">
                            <a-select-option v-for="(item, i) in this.$utils.townList" :value="item.id" :key="i">{{ item.name }}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="村庄" name="village">
                        <a-input v-model:value="formState.village"  placeholder="输入所在村庄"/>
                    </a-form-item>
                    <a-form-item label="姓名" name="name">
                        <a-input v-model:value="formState.name"  placeholder="输入您的姓名"/>
                    </a-form-item>
                    <a-form-item label="种植项目" name="growProject">
<!--                        <a-input v-model:value="formState.growProject"  placeholder="输入种植项目"/>-->
                        <a-select v-model:value="formState.growProject" placeholder="选择种植项目">
                            <a-select-option :value="'1'">小麦</a-select-option>
                            <a-select-option :value="'2'">玉米</a-select-option>
                            <a-select-option :value="'3'">果蔬</a-select-option>
                            <a-select-option :value="'4'">大蒜</a-select-option>
                            <a-select-option :value="'5'">花卉</a-select-option>
                            <a-select-option :value="'6'">农机</a-select-option>
                            <a-select-option :value="'7'">畜牧</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="贷款银行" name="insureCompany">
                        <a-select v-model:value="formState.insureCompany" placeholder="选择贷款银行">
                            <a-select-option :value="'1'">齐鲁银行商河支行</a-select-option>
                            <a-select-option :value="'2'">商河农商银行（信用社）</a-select-option>
                            <a-select-option :value="'3'">中国邮政储蓄银行商河支行</a-select-option>
                            <a-select-option :value="'4'">日照银行商河支行</a-select-option>
                            <a-select-option :value="'5'">商河汇金银行</a-select-option>
                            <a-select-option :value="'6'">中国建设银行商河支行</a-select-option>
                            <a-select-option :value="'7'">中国农业银行商河支行</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="贷款额度" name="loanLimit">
                        <a-input v-model:value="formState.loanLimit"  placeholder="输入贷款额度"/>
                    </a-form-item>
                    <a-form-item label="贷款用途" name="loanUse">
                        <a-input v-model:value="formState.loanUse"  placeholder="输入贷款用途"/>
                    </a-form-item>
                    <a-form-item label="联系电话" name="phone">
                        <a-input v-model:value="formState.phone"  placeholder="输入您的联系电话"/>
                    </a-form-item>
                    <a-form-item :wrapper-col="{ span: 24, offset: 5 }">
                        <a-button type="primary" @click="onSubmit" size="large" class="cus-button">发布</a-button>
                    </a-form-item>
                </a-form>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/portal/Header'
import Footer from "../../components/portal/Footer"
import { defineComponent, reactive, toRaw } from 'vue'
import {ref} from "@vue/runtime-dom"
import {notification} from "ant-design-vue"
import {addUserLoanApi} from "../../api/insure_loan"
export default defineComponent ({
    name: "Insurance",
    setup() {
        const formState = reactive({
            subjectName: undefined,
            town: undefined,
            village: undefined,
            name: undefined,
            growProject: undefined,
            insureCompany: undefined,
            loanLimit: undefined,
            loanUse: undefined,
            phone: undefined,
        })
        const formRef = ref()
        const rules = {
            town: [{ required: true, message: '请选择所在镇街', trigger: 'blur'}],
            subjectName: [{ required: true, message: '请输入主体名称', trigger: 'blur'}],
            village: [{required: true, message: '请输入村庄', trigger: 'blur'}],
            name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
            growProject: [{required: true, message: '请输入种植项目', trigger: 'blur'}],
            insureCompany: [{required: true, message: '请选择贷款银行', trigger: 'blur'}],
            loanLimit: [{required: true, message: '请输入贷款用途', trigger: 'blur'}],
            loanUse: [{required: true, message: '请输入贷款额度', trigger: 'blur'}],
            phone: [{required: true, message: '请输入联系电话', trigger: 'blur'}],
        }
        const onSubmit = async() => {
            formRef.value
                .validate()
                .then(() => {
                    const value = toRaw(formState)
                    const params = {
                        town: value.town,
                        subjectName: value.subjectName,
                        village: value.village,
                        name: value.name,
                        growProject: value.growProject,
                        insureCompany: value.insureCompany,
                        loanLimit: value.loanLimit,
                        loanUse: value.loanUse,
                        phone: value.phone,
                    }
                    addUserLoanApi(params).then(data => {
                        if (data) {
                            notification.success({ message: '提交成功！', duration: 2.5, description: '' })
                            setTimeout(() => {
                                location.reload()
                            }, 2000)
                        }
                        })
                    })
                .catch(error => {
                    console.log('error', error)
                })
        }
        return {
            labelCol: {
                span: 4,
            },
            wrapperCol: {
                span: 16,
                offset: 2
            },
            formState,
            rules,
            onSubmit,
            formRef
        }
    },
    components: {
        Header,
        Footer
    }
})
</script>

<style scoped lang="stylus">
.page {
    width 100%
    height 100%
    position relative
    font-size 16px
    background-color #FFF
    .header {
        width 100%
        height 730px
        padding-top 130px
        box-shadow 0 23px 120px rgba(0, 0, 0, 0.3)
        border-bottom-left-radius 315px
        border-bottom-right-radius 315px
        background-image url("../../assets/img/portal_service_bg.png")
        background-size 100% 100%
        background-repeat no-repeat
        z-index 1
        position relative
        .zt-title {
            margin-top 200px
            width 100%
            font-size 48px
            color #FFF
            font-weight bold
            text-align center
        }
    }
    .page-content {
        width 100%
        min-height 200px
        margin-top 80px
        padding 50px 20px
        .page-form {
            width 100%
            padding 30px
            background #FFF
        }
        .cus-button {
            width 50%
            height 50px
            line-height 50px
        }
    }
}
</style>